import { useEffect, useState } from "react";
import { Button } from "@/components/Button";
import { Modal } from "@/components/Modal";
import { H3, P } from "@/components/Typography";
import { useMatConfirmation } from "@/requests/hooks/mat";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

const OnboardingConfirmationModal = ({
  title,
  description,
  cancelButtonText,
  confirmButtonText,
  confirmationUrl,
  triggerButtonText,
  requestType,
}: IMatConfigurationConfirmationModalProperty) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const queryClient = useQueryClient();
  const { integration } = useParams();

  const toggleModal = () => setIsModalOpen(prev => !prev);

  const {
    isSuccess: isConfirmationSuccess,
    isPending: isConfirmationLoading,
    mutate: confirmationMutation,
  } = useMatConfirmation(integration!, queryClient);

  const handleConfirm = () => {
    confirmationMutation({
      confirmationUrl: confirmationUrl,
      method: requestType,
    });
  };

  useEffect(() => {
    if (isConfirmationSuccess) {
      toggleModal();
    }
  }, [isConfirmationSuccess]);

  return (
    <>
      <Button
        variant="primary"
        onClick={toggleModal}
        disabled={isConfirmationLoading}>
        {triggerButtonText}
      </Button>

      <Modal isOpen={isModalOpen} toggleIsOpen={toggleModal}>
        <div className="space-y-20">
          <H3>{title}</H3>
          <P>{description}</P>

          <div className="flex justify-end space-x-10 pt-20">
            <Button
              variant="secondary-outline"
              onClick={toggleModal}
              disabled={isConfirmationLoading}>
              {cancelButtonText}
            </Button>
            <Button
              variant="primary"
              onClick={handleConfirm}
              disabled={isConfirmationLoading}
              loading={isConfirmationLoading}>
              {confirmButtonText}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default OnboardingConfirmationModal;
